export const COMMENT_CHAR_LIMIT = 400

export enum FeedbackFilterType {
  All = 'all',
  Members = 'user',
  Auto = 'system',
}
